<template>
  <v-flex xs12 md12>
    <v-dialog v-model="dialog" width="1000" persistent>
      <template v-slot:activator="{ on }">
        <v-btn color="success" dark v-on="on">Create New Quiz</v-btn>
      </template>
      <v-card>
        <Form
          :Item="item"
          :Field="inputFields"
          :Value="valueObj"
          @emitted="submitExam"
          @closed="closeModal"
        />
      </v-card>
    </v-dialog>
    <material-card color="green" :title="quiz_title" text>
      <v-data-table  :headers="headers" :items="AllExamList">
        <template slot="headerCell" slot-scope="{ header }">
          <span class="subheading font-weight-light text--darken-3" v-text="header.text" />
        </template>
        <template slot="items" slot-scope="{ item }">
          <td @click="goQuizDetails(item)" class="click-route"> {{ item.exam_name }}</td>
          <td>{{ item.questions_count }}</td>
          <td>{{ item.duration }}</td>
          <td>{{ item.question_number }}</td>
          <td>{{ item.total_mark }}</td>
          <td>{{ item.negative_mark }}</td>
          <td>

            <v-btn
              color="green"
              v-if="item.status == 'unpublished' && item.questions_count >= item.question_number"
              @click="updateExam(item, 'published')"
            >Publish</v-btn>
            <v-btn
              color="warning"
              v-else-if="item.status == 'published' && item.questions_count >= item.question_number"
              @click="updateExam(item, 'unpublished')"
            >Unpublish</v-btn>
            <v-btn color="red" v-else>Unpublished</v-btn>
          </td>
          <td>
                <v-btn @click="getExamId(item)" color="success" dark>Add question</v-btn>
          </td>
        </template>
      </v-data-table>
    </material-card>
      <v-dialog v-model="dialogQuestion" width="1000" persistent>
        <template v-slot:activator="{ on }">
          <!-- <v-btn ref="questionInsertionDialog" color="success" dark v-on="on">Add question</v-btn> -->
        </template>
        <v-card>
          <FormExamQuestion :Data="examObj" @emitted="submitQuestion" @closedQuestion="closeQuestionModal" :QuestionNumber="examObj.questions_count" />
        </v-card>
      </v-dialog>
    <v-snackbar
      :color="color"
      :bottom="bottom"
      :top="top"
      :left="left"
      :right="right"
      v-model="snackbar"
      dark
    >
      <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
      <div>{{ noticeMessage }}</div>
      <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
    </v-snackbar>
  </v-flex>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FormExamQuestion from "@/views/FormExamQuestion";
import Form from "@/views/Form";
export default {
  components: {
    Form,
    FormExamQuestion
  },
  props: {
    AllExamList: Array
  },
  data() {
    return {
      // localExamList: this.AllExamList,
      color: null,
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      headers: [
        {
          sortable: true,
          text: "Quiz name",
          value: "exam_name"
        },
        {
          sortable: false,
          text: "Total question available",
          value: "questions_count"
        },
        {
          sortable: true,
          text: "Duration",
          value: "duration"
        },
        {
          sortable: true,
          text: "Total questions",
          value: "question_number"
        },
        {
          sortable: true,
          text: "Marks",
          value: "total_mark"
        },
        {
          sortable: true,
          text: "Negative Mark",
          value: "negative_mark"
        },
        {
          sortable: true,
          text: "Status",
          value: "status"
        },
        {
          sortable: false,
          text: "Action",
          value: ""
        }
      ],
      dialog: false,
      dialogQuestion: false,
      dialogEdit: false,
      noticeMessage: "",
      item: {
        title: "Create new Quiz",
        subTitle: "This is the subtitle",
        width: "md6",
        submitText: "Submit"
      },
      editItem: {},
      valueObj: {},
      inputFields: [
        {
          label: "Quiz Name",
          type: "text",
          isEnable: true,
          name: "exam_name",
          formName: "Exam name",
          nameRules: [
            v => !!v || "Quiz name is required",
            v =>
              (v && v.length <= 150) ||
              "Quiz name must be less than 150 characters"
          ]
        },
        {
          label: "Quiz Name Bangla",
          type: "text",
          isEnable: true,
          name: "exam_name_bn",
          formName: "Exam name Bangla",
          nameRules: [
            v => !!v || "Quiz name Bangla is required",
            v =>
              (v && v.length <= 150) ||
              "Quiz name must be less than 150 characters"
          ]
        },
        {
          label: "Duration",
          type: "number",
          isEnable: true,
          name: "duration",
          formName: "duration",
          nameRules: [v => !!v || "Duration is required"]
        },
        {
          label: "Total mark",
          type: "number",
          isEnable: true,
          name: "total_mark",
          formName: "Total mark",
          nameRules: [v => !!v || "Total mark is required"]
        },
        {
          label: "Number of questions",
          type: "number",
          isEnable: true,
          name: "question_number",
          formName: "Question number",
          nameRules: [v => !!v || "Question number is required"]
        },
        {
          label: "Positive mark",
          type: "number",
          isEnable: true,
          name: "positive_mark",
          formName: "Positive mark",
          nameRules: []
        },
        {
          label: "Negative mark",
          type: "number",
          isEnable: true,
          name: "negative_mark",
          formName: "Negative mark",
          nameRules: []
        }
      ],
      e_list: [],
      examObj: {}
    };
  },
  computed: {
    ...mapState("course_subjects", ["examList", "question", 'quizDetail', 'quiz_title'])
  },
  mounted() {
  },
  created() {
  },
  methods: {
    ...mapActions("course_subjects", [
      "getExamListByChapter",
      "storeExamGeneric",
      "storeQuestions",
      "storeQuestionsMultiple",
      "updateExamGeneric",
      'goDetailPage',
      'setQuizDetails'
    ]),
    getExamId (item) {
      this.examObj = item
      this.question.exam_id = item.id
      this.dialogQuestion = true
      // this.$refs.questionInsertionDialog.click()
    },
  
    submitExam(data) {
      let loader = this.$loading.show({
              color: "green",
              canCancel: true,
              onCancel: this.onCancel,
              loader: 'dots',
              isFullPage: true
            });
      data.status = "unpublished";
      data.chapter_id = this.question.chapter_id
        ? this.question.chapter_id
        : null;
      data.course_id = this.question.course_id;
      data.subject_id = this.question.subject_id;
      data.lecture_id = this.question.lecture_id
        ? this.question.lecture_id
        : null;
      this.storeExamGeneric(data)
        .then(response => {
          if (response.status === "OK") {
            this.dialog = false;
            this.color = "success";
            this.noticeMessage = "Success! " + response.messages;
            this.snack("top");
            this.AllExamList.push(response.result);
            loader.hide()
          } else {
            this.noticeMessage = response.messages;
            this.snack("top");
          loader.hide()
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    submitQuestion(items) {
      let loader = this.$loading.show({
              color: "green",
              canCancel: true,
              onCancel: this.onCancel,
              loader: 'dots',
              isFullPage: true
            });
            let data = {}
            data.chapter_id = this.question.chapter_id
            ? this.question.chapter_id
            : null;
            data.course_id = this.question.course_id
            data.subject_id = this.question.subject_id
            data.exam_id = this.question.exam_id
            data.lecture_id = this.question.lecture_id
            ? this.question.lecture_id
            : null;

          let q = [];
          items.forEach(element => {
            q.push({
            correct_answer: element.correct_answer  ? 1 : null,
            correct_answer2: element.correct_answer2  ? 2 : null,
            correct_answer3: element.correct_answer3  ? 3 : null,
            correct_answer4: element.correct_answer4  ? 4 : null,
            correct_answer5: element.correct_answer5  ? 5 : null,
            correct_answer6: element.correct_answer6  ? 6 : null,
            explanation_text: element.explanation_text ? element.explanation_text : null,
            option1:  element.option1,
            option2: element.option2,
            option3: element.option3,
            option4: element.option4,
            option5: element.option5,
            option6: element.option6,
            question: element.question
            });

        });
        data.items = q;       
      this.storeQuestionsMultiple(data)
        .then(response => {
          console.log(response);
          if (response.status === "OK") {       
            this.dialogQuestion = false;
            if (this.examObj.questions_count) {
              this.examObj.questions_count += 1 
            } else {
              this.examObj.questions_count = 1 
            }
            this.color = "success";
            this.noticeMessage = "Success! " + response.messages;
            this.snack("top");
          loader.hide()
          } else {
            this.noticeMessage = response.messages;
            this.snack("top");
          loader.hide()
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }
      this.snackbar = true;
    },
    closeQuestionModal() {
      this.dialogQuestion = false;
    },
    closeModal() {
      this.dialog = false
    },
    updateExam(data, status) {
      data.status = status;
      data.chapter_id = this.question.chapter_id
        ? this.question.chapter_id
        : null;
      data.course_id = this.question.course_id;
      data.subject_id = this.question.subject_id;
      data.lecture_id = this.question.lecture_id
        ? this.question.lecture_id
        : null;
      this.updateExamGeneric(data)
        .then(response => {
          console.log(response);
          if (response.status === "OK") {
            this.dialog = false;
            this.color = "success";
            this.noticeMessage =response.messages;
            this.snack("top");
          } else {
            this.color = "warning";
            this.noticeMessage = response.messages;
            this.snack("top");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goQuizDetails (item) {
      let self = this
      console.log(item)
      this.setQuizDetails(item).then(response => {
        self.$router.push('/quiz-details')
      })
    }
  }
}
</script>
<style  scoped>
.click-route {
  cursor: pointer;
  color: blue;
}

.click-route:hoiver {
  font-weight: bold;
  color: rgb(4, 4, 73);
}
</style>
